const baseEndpoint = 'api';
const services = 'services';
export const SpringRestConfig = {

  baseEndpoint,
  endpoints: {
    componenttypes: `${baseEndpoint}/komponententyp`,
    componentstatus: `${baseEndpoint}/komponentenstatus`,
    parameterstatus: `${baseEndpoint}/parameterstatus`,
    einheiten: `${baseEndpoint}/einheiten`,
    dimensionen: `${baseEndpoint}/dimensionen`,
    matrizen: `${baseEndpoint}/matrizen`,
    methoden: `${baseEndpoint}/methoden`,
    stoffe: `${baseEndpoint}/stoffe`,
    nichtstoffliche: `${baseEndpoint}/nichtstoffliche`,
    probevorbehandlungen: `${baseEndpoint}/probevorbehandlungen`,
    sonstigeKriterien: `${baseEndpoint}/sonstigeKriterien`,

    anforderungen: `${baseEndpoint}/alternativnamen`,
    alternativnamen: `${baseEndpoint}/stoffe`,

    parameter: `${baseEndpoint}/parameter`,

    importprotokolle: `${baseEndpoint}/importprotokolle`,
  },
  services: {
    komponente: `${baseEndpoint}/${services}/komponente`,
    parameter: `${baseEndpoint}/${services}/parameter`,
    excel: `${baseEndpoint}/${services}/excel`,

  }
};
